// import { GetPlanTaskList, getPlanTaskList } from '@/api/data-protection/plan-list'
import {
  bathDeleteTask,
  BathDeleteTask,
  ChangeJobStatus,
  changeJobStatus,
  deleteTask,
  DeleteTask,
  getTPBizAreaList,
  GetTPPlanList,
  getTPPlanTaskList,
  getTPTaskDetail,
  GetTPTaskDetail,
} from '@/api/threat-plan-list'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { ReactNode } from 'react'

type TaskListItem = {
  except_reason: ReactNode
  id: string
  name: string
  attack_agent_name: string
  attack_ip: string
  attack_area_name: string
  defense_agent_name: string
  defense_ip: string
  defense_area_name: string
  create_time: string
  task_time: string
  day_list: string[]
  scheduler_type: number
  task_status: number
}

type TaskDetail = Omit<TaskListItem, 'task_time' | 'day_list' | 'task_status'> & {
  action: number
  task_time_list: string[]
  plugin_name_list: string[]
}

export interface TaskListResult {
  items: TaskListItem[]
  total: number
}

// 获取计划任务列表
export const useGetPlanList = (props: GetTPPlanList) => {
  const { runAsync: run, data } = useRequest(() => getTPPlanTaskList(props), {
    refreshDeps: [props],
    onError(err: any) {
      Message.error(err?.msg || '获取计划任务列表失败')
    },
  })
  return [run, data?.data as TaskListResult] as const
}

// 获取安全域列表
export const useGetBizAreaList = () => {
  const { data } = useRequest(() => getTPBizAreaList(), {
    onError(err: any) {
      Message.error(err?.msg || '获取安全域列表失败')
    },
  })
  return [data?.data?.items || []] as const
}

// 获取计划详情
export const useGetTaskDetail = () => {
  const { runAsync: run, data } = useRequest((params: GetTPTaskDetail) => getTPTaskDetail(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取计划详情失败')
    },
  })
  return [run, data?.data as TaskDetail] as const
}

// 删除任务列表
export const useDeleteTask = () => {
  const { runAsync: run } = useRequest((data: DeleteTask) => deleteTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '删除任务列表失败')
    },
  })
  return [run] as const
}

// 批量删除任务列表
export const useBatchDeleteJob = () => {
  const { runAsync: run } = useRequest((data: BathDeleteTask) => bathDeleteTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '批量删除任务列表失败')
    },
  })
  return [run] as const
}

// 改变任务状态
export const useChangeJobStatus = () => {
  const { runAsync: run } = useRequest((params: ChangeJobStatus) => changeJobStatus(params), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '暂停/重启计划任务失败')
    },
  })

  return [run] as const
}
